var map = {
	"./activity history.svg": 5538,
	"./arrow_down.svg": 9478,
	"./cart.svg": 8373,
	"./copy.svg": 4114,
	"./dashboard.svg": 5884,
	"./dislike.svg": 7961,
	"./edit.svg": 8065,
	"./favorite deals.svg": 9160,
	"./get plan.svg": 9477,
	"./grid.svg": 6833,
	"./heart.svg": 9741,
	"./heart_filled.svg": 7993,
	"./like.svg": 3573,
	"./lngSwitchWhite.svg": 8854,
	"./my deals.svg": 4314,
	"./notification.svg": 7614,
	"./notification_off.svg": 1039,
	"./profile.svg": 5376,
	"./row.svg": 8429,
	"./settings.svg": 9900,
	"./star.svg": 5201,
	"./star_filled.svg": 2816,
	"./telegram.svg": 8685
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4310;